import DadosIcon from "@/assets/icons/revisao-dados.svg?react";
import { REVISAO } from "../../../nova-obra.constants";
import { textoOuTraco } from "../../etapa-revisao.utils";
import styles from "../../etapa-revisao.module.scss";
import { Campo } from "../campo";
import { Secao } from "../secao";
import type { SecaoDadosObraProps, SecaoDadosObraViewModel } from "./types-secao-dados-obra";

export function SecaoDadosObraView(props: SecaoDadosObraProps & SecaoDadosObraViewModel) {
  const { obra, embarcacao, local, statusObra, clientes, onEditar, statusFinanceiro } = props;

  return (
    <Secao id="dados-obra" Icone={DadosIcon} titulo={REVISAO.secoes.dadosObra} onEditar={onEditar}>
      <div className={styles.grupo}>
        <h4 className={styles.subtitulo}>{REVISAO.dados.identificacao}</h4>
        <div className={styles.linha}>
          <Campo rotulo={REVISAO.dados.embarcacao} valor={textoOuTraco(embarcacao)} />
          <Campo
            rotulo={REVISAO.dados.localPlanejado}
            valor={local ? local.nome : REVISAO.dados.localAdefinir}
          />
          <Campo
            rotulo={REVISAO.dados.manutencaoCorretiva}
            valor={obra.manutencaoCorretiva ? REVISAO.dados.sim : REVISAO.dados.nao}
          />
        </div>
      </div>
      <div className={styles.grupo}>
        <h4 className={styles.subtitulo}>{REVISAO.dados.statusCondicoes}</h4>
        <div className={styles.linha}>
          <Campo rotulo={REVISAO.dados.statusObra} valor={textoOuTraco(statusObra)} />
          <Campo rotulo={REVISAO.dados.statusFinanceiro} valor={statusFinanceiro} />
        </div>
      </div>
      {/* Figma 10732:712185: o bloco de cliente vem entre Status e Detalhes, com divisórias. O comentário
          de 10/10 (2543) troca "Cliente atual/futuro" por "Cliente deste Contrato" e tira o subtítulo
          "Embarcação" que sobrava. */}
      <div className={`${styles.grupo} ${styles.grupoDivisorias}`}>
        <div className={styles.linha}>
          <Campo
            rotulo={REVISAO.clienteContrato}
            valor={clientes.length > 0 ? clientes.join(", ") : REVISAO.vazio}
            testId="revisao-cliente-contrato"
          />
        </div>
      </div>
      <div className={styles.grupo}>
        <h4 className={styles.subtitulo}>{REVISAO.dados.detalhes}</h4>
        <Campo rotulo={REVISAO.dados.observacoes} valor={textoOuTraco(obra.observacoes)} />
        <Campo rotulo={REVISAO.dados.descricao} valor={textoOuTraco(obra.descricao)} />
      </div>
    </Secao>
  );
}
